// extracted by mini-css-extract-plugin
export default {"btn":"AddTaskBtn_btn__5uJ13","btnIcon":"AddTaskBtn_btnIcon__SwZ4O"};